import axios from 'axios'
import {Message} from 'element-ui';
//引入cookie
import {getCookies, setCookies} from './auth'
import store from './../store';
const service = axios.create({
  baseURL: process.env.NODE_ENV === "production"?process.env.BASE_URL:'/api',
  // baseURL: process.env.BASE_URL, // url = base url + request url  引入全局url，定义在全局变量process.env中，开发环境为了方便转发，值为空字符串
  withCredentials: true, // 跨域请求时发送cookie
  timeout: 50000 // request timeout
});
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做一些事情
    if (false) {
      //让每个请求都携带令牌
      // ['X-Token']是一个自定义标题键
      //请根据实际情况进行修改
      // config.headers['X-Token'] = getCookies()
    }
     config.headers['X-PDD-Pati'] = getCookies('pati')
     config.headers['X-PDD-PageCode'] = getCookies('X-PDD-PageCode')
     config.headers['companyId'] = getCookies('BYTENEWCID')
    return config
  },
  error => {
    return Promise.reject(error)
  }
);

// 响应拦截器
service.interceptors.response.use(
  /**
   *如果您想获取标题或状态等http信息
   *请返回响应=>响应
   *通过自定义代码确定请求状态
   *这只是一个例子
   *您还可以通过HTTP状态代码判断状态
   */
  response => {
    let res = response.data;
    //判断有没有code，有的话就转化为数值，没有就抛出异常
    /* code 值
    * UNREALIZED -1 方法和类没有实现
    * OK ok
    * PARAM_ERROR 1000 param_error
    * UPDATE_ERROR 2000 更新出现错误
    * CREATE_ERROR 3000 创建出现错误
    * DELETE_ERROR 4000 删除出现错误
    * NULL_ERROR  5000 空错误
    * ERROR  10000 有错误
    * */
    if (res.code == null) {
      res = {
        code: 10000,
        msg: '接口'+response.config.url+'调用异常'
      }
    }
    if (res.code == 820 || res.code >= 10000) {
      let traceId = response.headers['trace-id']
      Message({
        message: res.msg +'；'+':'+ traceId,
        type: res.code == 10000?'error':'warning',
        duration: 5000
      });
    }
    return res
  },
  error => {
    console.log(error)
    let url = error.response?error.response.config.url.replace(error.response.config.baseURL, ''):'';
    let msg = '平台API ' + url + ' 调用异常.==>' + error.response.status;
    Message({
      message: msg,
      type: 'warning',
      duration: 5000
    });
    return {
      code: 8080,
      msg: msg
    }
  }
);
export default service



// WEBPACK FOOTER //
// ./src/util/request.js